import React from "react";
import "../../UserSetting/toggle-css.css";
import styles from "../settings.module.css";

function Payments() {

  // const handleStripe = (e) => {
  //   e.preventDefault();
  //   const payload = {
  //     customer_id: user.id,
  //   };
  //   dispatch(stripeConnect(payload));
  // };
  return (
    <div mt-1>
      <div className="pb-2 d-flex flex-direction-column">
        <h2 className={styles.settings__header}>Stripe Payments Settings</h2>
      </div>
      <div className="pl-sm-3">
        <p className="pt-2">Stripe integration coming soon!</p>
        <p>
          The Beehaz development team is working on this feature.
          <br />
          Soon you will be able to connect your Stripe account to Beehaz!
        </p>
      </div>
    </div>
  );
}

export default Payments;
